var _ellipse, _ellipse2, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShippingICon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 36,
    rx: 35.5,
    ry: 36,
    fill: "#64CD82",
    fillOpacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8182,
    cy: 36.1818,
    rx: 25.8182,
    ry: 26.1818,
    fill: "#64CD82",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5977_19463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5977_19463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 22H22V49.5246H50V22Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5977_19463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.035 28.8975C23.7529 29.5422 25.4008 30.1629 27.0488 30.7804C29.6016 31.7377 32.1555 32.6939 34.7105 33.6469C34.9597 33.7397 35.1367 33.8195 35.1356 34.1627C35.1214 39.206 35.1247 44.2504 35.1225 49.2937C35.1225 49.3473 35.1061 49.4008 35.0875 49.5145C34.9083 49.4555 34.7411 49.4063 34.5772 49.3451C30.5261 47.8261 26.4762 46.3038 22.4229 44.7924C22.1344 44.6842 21.9989 44.5597 22 44.2187C22.0131 39.23 22.0087 34.2403 22.0098 29.2515C22.0098 29.1608 22.0219 29.0712 22.035 28.8975ZM25.5101 41.5162C25.5101 42.1052 25.5003 42.6287 25.5189 43.151C25.5221 43.2505 25.6128 43.4013 25.7003 43.4352C26.7778 43.8515 27.8629 44.2515 29.0016 44.6766C29.0016 44.0876 29.0115 43.5641 28.9929 43.0418C28.9896 42.9423 28.8989 42.7915 28.8115 42.7576C27.734 42.3402 26.6499 41.9413 25.5101 41.5162Z",
    fill: "#64CD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8714 49.5245C36.8714 49.2786 36.8714 49.1158 36.8714 48.953C36.8714 44.0899 36.8791 39.228 36.8594 34.365C36.8572 33.9192 36.9971 33.741 37.4036 33.599C38.6691 33.1575 39.9171 32.6679 41.2328 32.1739C41.2328 33.6449 41.2328 35.0404 41.2328 36.5364C41.8339 36.3179 42.3715 36.131 42.9026 35.9256C43.5092 35.6906 44.3288 35.5966 44.6468 35.1508C44.9506 34.7246 44.7342 33.9235 44.7397 33.2875C44.7451 32.5958 44.7287 31.9029 44.7506 31.2111C44.755 31.0658 44.85 30.8363 44.9615 30.7926C46.6018 30.1544 48.2509 29.5402 49.9906 28.8867C49.9906 29.1523 49.9906 29.3413 49.9906 29.5304C49.9906 34.3749 49.9841 39.2193 50.0026 44.0637C50.0048 44.5019 49.8748 44.6822 49.465 44.8341C45.4576 46.3171 41.4601 47.8263 37.4604 49.3267C37.2911 49.3901 37.1195 49.4414 36.8714 49.5245Z",
    fill: "#64CD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.229 30.4253C39.4718 31.0865 37.8424 31.7061 36.2064 32.305C36.0567 32.3596 35.8436 32.3236 35.6841 32.2635C31.2407 30.6067 26.7995 28.9424 22.3594 27.2769C22.2808 27.2474 22.2119 27.195 22.0742 27.1185C23.8336 26.4584 25.533 25.8224 27.2323 25.1842C29.9883 24.1493 32.7411 23.1079 35.5038 22.0904C35.7671 21.9932 36.1234 21.9626 36.378 22.0577C40.793 23.6892 45.1981 25.3448 49.6054 26.9961C49.6895 27.0278 49.7682 27.0726 49.9332 27.1502C49.6043 27.2802 49.3475 27.3851 49.0874 27.4835C47.8121 27.9632 46.5324 28.432 45.2626 28.9271C44.8987 29.0691 44.5916 29.068 44.2277 28.8997C42.7939 28.2331 41.3503 27.5884 39.8947 26.9698C39.6652 26.8726 39.3297 26.877 39.0947 26.9677C38.0959 27.3534 37.1168 27.7905 36.0065 28.2605C37.7768 28.9926 39.4423 29.6844 41.229 30.4253Z",
    fill: "#64CD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5104 41.5166C26.6502 41.9417 27.7343 42.3406 28.8118 42.758C28.8992 42.7919 28.9899 42.9427 28.9932 43.0422C29.0107 43.5645 29.0019 44.088 29.0019 44.677C27.8621 44.2519 26.7781 43.853 25.7006 43.4356C25.6142 43.4017 25.5224 43.2509 25.5192 43.1514C25.5006 42.6291 25.5104 42.1067 25.5104 41.5166Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5977_19463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(22 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingICon);
export default __webpack_public_path__ + "static/media/shippingICon.94f86045ad4c74fc801adf81b2769192.svg";
export { ForwardRef as ReactComponent };